import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import * as types from 'constants/actionTypes';
import moment from 'moment';
class LotNumberSelect extends Component {
    constructor(props) {
        super(props);
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };

        this.onChange = this.onChange.bind(this);
        this.getTextForValue = this.getTextForValue.bind(this);
    }

    componentWillMount() {
        if (!this.state.value && this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue });
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value !== this.state.value) {
            this.setState({ value: newProps.value });
        }

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    menuItems(options) {
        const recentPODateStyle = {
            width: '80%',
            color: 'green',
            fontSize: '12px'
        };


        return options.map((option) => (
            //var test = 'karl';


            <MenuItem key={option.value} value={option.value}>
                <div>
                    <div>
                        {option.text}
                    </div>
                    <div style={recentPODateStyle}>
                        Most Recent PO Date:{this.getMostRecentPODateFromLotNumber(option.value)}
                    </div>
                </div>
            </MenuItem>
        ));
    }

    getMostRecentPODateFromLotNumber(lotNumber) {
        let packages = this.props.itemDetail.inventoryAdjustPackageDTO;
        if (lotNumber == '0') {
            let atleastOneValidDate = packages.find(_ => Date.parse(_.mostRecentPoDate) > 0);
            if (atleastOneValidDate) {
                return moment(new Date(Math.max.apply(null, packages.map(function (e) {
                    return new Date(e.mostRecentPoDate);
                }))).toString()).format('YYYY-MM-DD');
            } else {
                return 'N.A.';
            }

        }
        else if (lotNumber == 'None') {
            return packages.find(_ => _.packageReference == '').mostRecentPoDate ? moment(packages.find(_ => _.packageReference == '').mostRecentPoDate).format('YYYY-MM-DD') : 'N.A.';
        } else {
            return packages.find(_ => _.packageReference == lotNumber).mostRecentPoDate ? moment(packages.find(_ => _.packageReference == lotNumber).mostRecentPoDate).format('YYYY-MM-DD') : 'N.A.';
        }
    }

    onChange = (event) => {
        const p = this.props;
        const newValue = event.target.value;
        const newTarget = p.options.find(item => item.value === newValue);
        this.setState({ ...this.state, value: newValue });

        this.props.dispatch({ type: types.FORM_INPUT, value: newValue, name: p.name });
        this.props.dispatch({ type: types.FORM_INPUT, value: newTarget.text, name: `${p.name}Text` });
        let productId = p.name.split('_')[2];
        if (newValue === '0') {
            let poPrice = (p.itemDetail.avgPurchasePrice || 0).toFixed(2);
            let latestPOPrice = (p.itemDetail.latestPurchasePrice || 0).toFixed(2);
            this.props.dispatch({ type: types.FORM_INPUT, value: (p.itemDetail.thcLevel || 0).toFixed(2), name: `inventoryAdjust_THCLevel_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: (p.itemDetail.cbdLevel || 0).toFixed(2), name: `inventoryAdjust_CBDLevel_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: p.itemDetail.estimatedQty, name: `inventoryAdjust_estimatedQty_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: poPrice, name: `inventoryAdjust_avgPOPrice_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: latestPOPrice, name: `inventoryAdjust_latestPOPrice_${productId}` });
            if (poPrice > 0) {
                this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - poPrice) / poPrice * 100).toFixed(2), name: `inventoryAdjust_markup_${productId}` });
            }
            this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - poPrice) / this.props.salePrice * 100).toFixed(2), name: `inventoryAdjust_margin_${productId}` });

            if (latestPOPrice > 0) {
                this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - latestPOPrice) / latestPOPrice * 100).toFixed(2), name: `inventoryAdjust_latestMarkup_${productId}` });
            }
            this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - latestPOPrice) / this.props.salePrice * 100).toFixed(2), name: `inventoryAdjust_latestMargin_${productId}` });
        } else if (newValue === 'None') {
            let poPrice = (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference == '').baseCost || 0).toFixed(2);
            let latestPOPrice = (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference == '').lastestPurchaseOrderCost || 0).toFixed(2);
            this.props.dispatch({ type: types.FORM_INPUT, value: (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference == '').thC_Level || 0).toFixed(2), name: `inventoryAdjust_THCLevel_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference == '').cbD_Level || 0).toFixed(2), name: `inventoryAdjust_CBDLevel_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference == '').potencyShow || false), name: `inventoryAdjust_showPotency_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference == '').quantity || 0), name: `inventoryAdjust_estimatedQty_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: poPrice, name: `inventoryAdjust_avgPOPrice_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: latestPOPrice, name: `inventoryAdjust_latestPOPrice_${productId}` });
            if (poPrice > 0) {
                this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - poPrice) / poPrice * 100).toFixed(2), name: `inventoryAdjust_markup_${productId}` });
            }
            this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - poPrice) / this.props.salePrice * 100).toFixed(2), name: `inventoryAdjust_margin_${productId}` });

            if (latestPOPrice > 0) {
                this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - latestPOPrice) / latestPOPrice * 100).toFixed(2), name: `inventoryAdjust_latestMarkup_${productId}` });
            }
            this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - latestPOPrice) / this.props.salePrice * 100).toFixed(2), name: `inventoryAdjust_latestMargin_${productId}` });
        } else {
            let poPrice = (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference === newValue).baseCost || 0).toFixed(2);
            let latestPOPrice = (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference === newValue).lastestPurchaseOrderCost || 0).toFixed(2);
            this.props.dispatch({ type: types.FORM_INPUT, value: (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference === newValue).thC_Level || 0).toFixed(2), name: `inventoryAdjust_THCLevel_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference === newValue).cbD_Level || 0).toFixed(2), name: `inventoryAdjust_CBDLevel_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference === newValue).potencyShow || false), name: `inventoryAdjust_showPotency_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: (p.itemDetail.inventoryAdjustPackageDTO.find(_ => _.packageReference === newValue).quantity || 0), name: `inventoryAdjust_estimatedQty_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: poPrice, name: `inventoryAdjust_avgPOPrice_${productId}` });
            this.props.dispatch({ type: types.FORM_INPUT, value: latestPOPrice, name: `inventoryAdjust_latestPOPrice_${productId}` });
            if (poPrice > 0) {
                this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - poPrice) / poPrice * 100).toFixed(2), name: `inventoryAdjust_markup_${productId}` });
            }
            this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - poPrice) / this.props.salePrice * 100).toFixed(2), name: `inventoryAdjust_margin_${productId}` });

            if (latestPOPrice > 0) {
                this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - latestPOPrice) / latestPOPrice * 100).toFixed(2), name: `inventoryAdjust_latestMarkup_${productId}` });
            }
            this.props.dispatch({ type: types.FORM_INPUT, value: ((this.props.salePrice - latestPOPrice) / this.props.salePrice * 100).toFixed(2), name: `inventoryAdjust_latestMargin_${productId}` });
        }
    }
    getTextForValue(value) { const option = this.props.options.find(opt => opt.value === value); return option ? option.text : ''; }

    render() {
        const p = this.props;
        const e = this.state && this.state.error;
        const value = this.state && this.state.value;
        //maybe fix here
        const { options, className, error, dispatch, defaultValue, itemDetail, ...textProps } = { ...p };
        if (!p.options) return null;

        return (<div className={p.className || "form-group lotFormStyle"}>
            {/* <span className="">
                Lot#
            </span> */}

            <FormControl
                error={e && value}
                className={this.className}
                fullWidth
            >
                <InputLabel>Lot Number</InputLabel>
                <Select
                    {...textProps}
                    value={value}
                    onChange={this.onChange}
                    label="Lot Number"
                    renderValue={this.getTextForValue}
                    variant='standard'
                >
                    {this.menuItems(p.options)}
                </Select>
                {e && !value && (
                    <FormHelperText>{p.error}</FormHelperText>
                )}
            </FormControl>
        </div>);
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name]
    };
};

export default connect(mapStateToProps)(LotNumberSelect);
